import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Alert } from "react-bootstrap";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import { Spin } from "antd";
import DropDownModal from "./dropDownModal";
import ScenarioCollection from "./scenarioCollectionComponent";
import CartComponent from "./cartComponent";

function main(props) {
    const loadingTip = "scenario group creation in progress..."
    return (
        <div style={{ padding: "1rem" }}>
            <Breadcrumb>
                <Breadcrumb.Item href="">
                    <Link to="navigate_new">Home</Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item href="">
                    <Link to="/landingtestmanagement">Welcome</Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item href="">
                    {" "}
                    <Link to="/close_loop">Close loop</Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item href="/close_loop_scenario_group" active>
                    Base Scenario Collection
                </Breadcrumb.Item>
            </Breadcrumb>
            <Spin spinning={props.loading} tip={loadingTip}>
                <div className="row" style={{ backgroundColor: "#F3F3F3" }}>
                    <div
                        className="col-lg-12"
                        style={{
                            display: "inline-block",
                            padding: "0rem 1rem",
                        }}
                    >
                        {props.simulatorErrorStatus ||
                        props.modalErrorStatus ||
                        props.modalVersionErrorStatus ||
                        props.featureErrorStatus ||
                        props.baseScenarioErrorStatus ||
                        props.addVariationToGroupErrorStatus ? (
                            <Alert key="danger" variant="danger">
                                {props.simulatorErrorStatus ||
                                    props.modalErrorStatus ||
                                    props.modalVersionErrorStatus ||
                                    props.featureErrorStatus ||
                                    props.baseScenarioErrorStatus ||
                                    props.addVariationToGroupErrorStatus}
                            </Alert>
                        ) : undefined}
                    </div>
                    <div
                        className="col-lg-10"
                        style={{
                            display: "inline-block",
                            padding: "0rem 1rem",
                        }}
                    >
                        <DropDownModal />
                    </div>
                    <div
                        className="col-lg-2"
                        style={{
                            display: "inline-block",
                            padding: "1rem",
                            float: "right",
                        }}
                    >
                        <div>
                            <CartComponent />
                        </div>
                        <div
                            className="col-lg-12"
                            style={{
                                display: "inline-block",
                                padding: "2.5rem 0rem 0rem 0rem",
                            }}
                        >
                            {/* <Link
                                to={{
                                    pathname:
                                        "close_loop_scenario_collection_enhanced/scenario_file/upload",
                                }}
                                style={{ textDecoration: "none" }}
                                // target="_blank"
                            > */}
                            {/*<button
                                className="btn"
                                style={{
                                    backgroundColor: "#757AF7",
                                    color: "#FFFFFF",
                                    border: "0rem",
                                    borderRadius: "0.2rem",
                                    // padding: "0.5rem",
                                    width: "11.5rem"
                                }}
                                // onClick={viewUploadVariationHandler}
                            >
                                Reset
                                <i
                                    className="fa fa-sync"
                                    aria-hidden="true"
                                    style={{ margin: "0 0.3rem" }}
                                ></i>
                            </button>*/}
                            {/* </Link> */}
                        </div>
                    </div>
                </div>
                <div className="row">
                    <ScenarioCollection />
                </div>
            </Spin>
        </div>
    );
}

const mapStateToProps = (state) => ({
    simulatorErrorStatus: state.DropDownSimulatorData.error,
    modalErrorStatus: state.DropDownModelData.error,
    modalVersionErrorStatus: state.DropDownModelVersionData.error,
    featureErrorStatus: state.DropDownFeatureReducer.error,
    baseScenarioErrorStatus: state.DropDownBaseScenarioReducer.error,
    addVariationToGroupErrorStatus: state.addVariationToGroupStatus.error,
    loading: state.addVariationToGroupStatus.loading,
});

export default connect(mapStateToProps, undefined)(main);
